export default __webpack_public_path__ + "static/media/Hair_3_M_C3.8419fff0.svg";